document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".rich-text__text.rte ul li");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add("fade-in-up");
          }, index * 200); // stagger effect
        }
      });
    },
    {
      threshold: 0.2,
    }
  );

  items.forEach((item) => {
    observer.observe(item);
  });
});